import { updatePlanningShiftTableState } from '@/entities/gridTables/thunks/updatePlanningShiftTableState'
import { planningShiftsSelectors, StopTypeEnum } from '@/entities/schedules'
import { ThunkApiContext } from '@/shared/store'
import { createAsyncThunk, EntityId } from '@reduxjs/toolkit'

import { ordersSelectors } from '../ordersSelectors'
import { fetchPlanningOrders } from './fetchPlanningOrders'

type FetchOrdersByShiftsPayload = {
  shiftIds: EntityId[]
  forceRefresh?: boolean
}

export const fetchPlanningOrdersByShifts = createAsyncThunk<void, FetchOrdersByShiftsPayload, ThunkApiContext>('orders/fetchPlanningOrdersByShifts',
  async ({ shiftIds, forceRefresh }, { dispatch, getState }) => {
    const state = getState()
    const allPlanningShifts = planningShiftsSelectors.selectAll(state)
    const relevantPlanningShifts = allPlanningShifts.filter((shift) => shiftIds.includes(shift.id))

    const orderIds: EntityId[] = []

    relevantPlanningShifts.forEach((shift) => {
      if (shift.loads && shift.loads.length > 0) {
        const shiftOrderIds = shift.loads
          .flatMap(load => load.stops.map(stop => stop.stopType === StopTypeEnum.Order ? stop.orderId : undefined))
          .filter((orderId) => orderId !== undefined)
          .filter((orderId) => forceRefresh ? true : (orderId && !ordersSelectors.selectById(state, orderId)))

        orderIds.push(...(shiftOrderIds as EntityId[]))
      }
    })

    if (orderIds.length > 0) {
      await dispatch(fetchPlanningOrders({ orderIds }))
    }

    // Update the planning shift tables state
    relevantPlanningShifts.forEach(async (shift) => {
      await dispatch(updatePlanningShiftTableState({ shiftId: shift.id }))
    })
  },
)
